// src/components/FilterResultHeader/SeasonsToggle.tsx
import IconRadioGrp from "../IconRadioGrp";
import { Tooltip } from "reactstrap";
import type { TooltipProps } from "reactstrap";

type Props = {
  hasSeasons: boolean;
  getOverallSeason: () => string;
  updateOverallSeason: (season: string) => void;
  commonTooltipProps: Pick<TooltipProps, "placement" | "container" | "modifiers">;
  tooltipOpen: { seasons: boolean; display: boolean };
  toggleTooltip: (k: keyof Props["tooltipOpen"]) => void;
};

export function SeasonsToggle({
  hasSeasons,
  getOverallSeason,
  updateOverallSeason,
  commonTooltipProps,
  tooltipOpen,
  toggleTooltip,
}: Props) {
  return (
    <>
      <span
        id="btnResultsSeasons"
        style={{
          cursor: "pointer",
          opacity: hasSeasons ? 1 : 0.5,
        }}
        className="p-1"
      >
        <IconRadioGrp
          array={[
            { name: "summer", color: "warning", icon: "sun" },
            { name: "winter", color: "info", icon: "snowflake" },
            { name: "All", color: "light", icon: "all" },
          ]}
          value={getOverallSeason()}
          setValue={
            hasSeasons ? (e: { season: string }) => updateOverallSeason(e.season) : () => {}
          }
        />
      </span>

      <Tooltip
        isOpen={tooltipOpen.seasons}
        target="btnResultsSeasons"
        toggle={() => toggleTooltip("seasons")}
        {...commonTooltipProps}
      >
        Set all seasonal values
      </Tooltip>
    </>
  );
}
